import { randomizeChildren } from './randomize';
import widgetTypes from './constants/widgetTypes';
import { ColumnGrid, Banner, Image, TextGrid, TextOnly, Carousel, CarouselChild, SeoData, SlidingWidget, InFocus, AppConfig, FitcodeProfile, ButtonGrid, Button, SlidingWidgetV2, BannerV2, ColumnGridV2, CarouselV2, SectionWrapper, Recommendation, Product, Story, ProductV2, ProductV2Child, Video, } from './widgets';
import { cookDevModeShareableData } from './helper';
import { listViewChild, listViewWidget } from './widgets/others';
export const widgetTransformer = (widgetData, inheritParams, store, pagePrefix, previewMode = false) => {
    const { wtype } = widgetData;
    const newWidgetData = Object.assign(Object.assign(Object.assign({}, widgetData), inheritParams), { store,
        pagePrefix,
        previewMode });
    const widgetType = wtype;
    let transformed = {};
    const devModeData = cookDevModeShareableData(widgetData);
    switch (widgetType) {
        case widgetTypes.BANNER: {
            transformed = Banner(newWidgetData);
            break;
        }
        case widgetTypes.COLUMN_GRID: {
            transformed = ColumnGrid(newWidgetData);
            break;
        }
        case widgetTypes.IMAGE: {
            transformed = Image(newWidgetData);
            break;
        }
        case widgetTypes.TEXT_GRID: {
            transformed = TextGrid(newWidgetData);
            break;
        }
        case widgetTypes.TEXT_ONLY: {
            transformed = TextOnly(newWidgetData);
            break;
        }
        case widgetTypes.CAROUSEL: {
            transformed = Carousel(newWidgetData);
            break;
        }
        case widgetTypes.CAROUSEL_CHILD: {
            transformed = CarouselChild(newWidgetData);
            break;
        }
        case widgetTypes.SLIDING_WIDGET: {
            transformed = SlidingWidget(newWidgetData);
            break;
        }
        case widgetTypes.SEO_DATA: {
            transformed = SeoData(newWidgetData);
            break;
        }
        case widgetTypes.IN_FOCUS: {
            transformed = InFocus(newWidgetData);
            break;
        }
        case widgetTypes.APP_CONFIG: {
            transformed = AppConfig(newWidgetData);
            break;
        }
        case widgetTypes.FITCODE_PROFILE: {
            transformed = FitcodeProfile(newWidgetData);
            break;
        }
        case widgetTypes.BUTTON_GRID: {
            transformed = ButtonGrid(newWidgetData);
            break;
        }
        case widgetTypes.BUTTON: {
            transformed = Button(newWidgetData);
            break;
        }
        case widgetTypes.SLIDING_WIDGET_V2: {
            transformed = SlidingWidgetV2(newWidgetData);
            break;
        }
        case widgetTypes.BANNER_V2: {
            transformed = BannerV2(newWidgetData);
            break;
        }
        case widgetTypes.COLUMN_GRID_V2: {
            transformed = ColumnGridV2(newWidgetData);
            break;
        }
        case widgetTypes.CAROUSEL_V2: {
            transformed = CarouselV2(newWidgetData);
            break;
        }
        case widgetTypes.SECTION: {
            transformed = SectionWrapper(newWidgetData);
            break;
        }
        case widgetTypes.RECOMMENDATION_WIDGET: {
            transformed = Recommendation(newWidgetData);
            break;
        }
        case widgetTypes.PRODUCT_WIDGET_V2: {
            transformed = ProductV2(newWidgetData);
            break;
        }
        case widgetTypes.PRODUCT_WIDGET: {
            transformed = Product(newWidgetData);
            break;
        }
        case widgetTypes.PRODUCT_WIDGET_V2_CHILD: {
            transformed = ProductV2Child(newWidgetData);
            break;
        }
        case widgetTypes.STORY: {
            transformed = Story(newWidgetData);
            break;
        }
        case widgetTypes.VIDEO: {
            transformed = Video(newWidgetData);
            break;
        }
        case widgetTypes.LIST_VIEW_WIDGET: {
            transformed = listViewWidget(newWidgetData);
            break;
        }
        case widgetTypes.LIST_VIEW_CHILD: {
            transformed = listViewChild(newWidgetData);
            break;
        }
        default: {
            return {};
        }
    }
    if (inheritParams) {
        const { params } = transformed;
        transformed.params = Object.assign(Object.assign({}, params), inheritParams);
    }
    transformed.devModeData = devModeData;
    return transformed;
};
export const widgetsTransformer = (widgets, addedParams = {}, store, pagePrefix, previewMode = false) => {
    const parentData = widgetTransformer(widgets, addedParams, store, pagePrefix, previewMode);
    const { children, inventoryName, trackingData, inventoryId, } = widgets;
    const { inheritParams, widgetType } = parentData;
    const transformedChilds = children && children.map((child) => {
        const childWidget = Object.assign(Object.assign({}, child), { inventoryName,
            inventoryId,
            trackingData, pwType: widgetType, wtype: widgetType === widgetTypes.PRODUCT_WIDGET_V2 ? widgetTypes.PRODUCT_WIDGET_V2_CHILD : child.wtype });
        if (childWidget.children) {
            return widgetsTransformer(childWidget, Object.assign(Object.assign({}, inheritParams), addedParams), store, pagePrefix, previewMode);
        }
        return widgetTransformer(childWidget, Object.assign(Object.assign({}, inheritParams), addedParams), store, pagePrefix, previewMode);
    });
    parentData.children = randomizeChildren(transformedChilds);
    return parentData;
};
export const inventoryTransformer = (data, isDesktop, store, pagePrefix, offset = 0, previewMode = false) => {
    const { widget_data: widgetData, inventory_name: inventoryName, inventory_page_section: inventoryPageSection, position, inventory_id: inventoryId, inventory_page_type: inventoryPageType, inventory_page_data: inventoryPageData, inventory_lang: inventoryLang, api_page_data: apiPageData, visibility, personalization, isDataPersonalized, } = data;
    widgetData.inventoryName = inventoryName;
    widgetData.inventoryId = inventoryId;
    const trackingData = {
        namespace0: inventoryPageType,
        namespace1: inventoryPageSection,
        lang: inventoryLang || 'en',
        position1: position + offset,
        pageData1: apiPageData || '',
        pageData2: inventoryPageData || '',
    };
    widgetData.trackingData = trackingData;
    return {
        inventoryName,
        inventoryId,
        inventoryPageType,
        inventoryPageSection,
        inventoryPageData,
        apiPageData,
        visibility,
        position: position + offset,
        personalization,
        isDataPersonalized,
        widgetData: widgetsTransformer(widgetData, { isDesktop }, store, pagePrefix, previewMode),
    };
};
